export var COLOR_PICKERS_TO_ATTRIBUTES_MAPPING = {
  'panel-primary-background': {
    '.payment-description .item': 'background',
    '.payment-form': 'background',
    '.billing-address': 'background',
    '.descriptor-container': 'background',
    '.payment-form-footer': 'background'
  },
  'panel-secondary-background': {
    '.amount': 'background',
    '#transaction-types-form-container': 'background'
  },
  'panel-tertiary-background': {
    '.transaction-types': 'background',
    '.transaction-types input:not(:checked) + label span': 'color',
    '.transaction-types input + label': 'border-color'
  },
  required: {
    'abbr[title]': 'color'
  },
  border: {
    'input:not(.focused)': 'border-color',
    select: 'border-color',
    '.chosen-single': 'border-color',
    '.descriptor-container .descriptor-title': 'background',
    'input[type="checkbox"] + label': 'border-color',
    hr: 'border-bottom-color'
  },
  'logo-border': {
    '.merchant-logo img': 'border-right-color'
  },
  'language-selected': {
    '.language-selector-wrapper a.selected': 'color'
  },
  text: {
    '.transaction-types input[type="radio"]:checked + label span': 'border-color',
    label: 'color',
    body: 'color',
    'a.cancel': 'color',
    '.transaction-types input:checked + label span': 'color',
    '.item': 'color'
  },
  'input-background': {
    select: 'background',
    '.chosen-container .chosen-single': 'background',
    '.chosen-container .chosen-drop': 'background',
    'input[type="checkbox"] + label': 'background',
    'input:not([type=submit])': 'background'
  },
  background: {
    body: 'background',
    'input[type="checkbox"] + label::after': 'color',
    '.main': 'background',
    '.header': 'background'
  },
  'input-text': {
    select: 'color',
    '.chosen-container .chosen-single': 'color',
    '.security-hint': 'color',
    '.tac a': 'color',
    'input:not(.focused, [type=submit])': 'color'
  },
  'logo-background': {
    '.merchant-logo': 'background',
    'input[type=submit]': 'color',
    '.wpf_form_tac input[type="checkbox"]:checked + label:after': 'background'
  },
  primary: {
    '.transaction-types input[type="radio"]:checked + label': 'border-color',
    '.billing-address h4': 'color',
    '.transaction-type-form h4': 'color',
    '.amount': 'color',
    '.purchase-description h3': 'color',
    '.wpf_form_tac input[type="checkbox"] + label:hover': 'border-color',
    '.wpf_form_tac input[type="checkbox"]:checked+label': ['border-color', 'border', 'background'],
    'input[type="radio"]:checked + label': 'border-color',
    'input[type="radio"]:hover + label': 'border-color',
    'input.focused': 'color',
    '.focused': 'border-color',
    'input[type="submit"]': 'background'
  }
};
export var THEMES = {
  light: {
    'panel-primary-background': '#fff',
    'panel-secondary-background': '#fff',
    'panel-tertiary-background': '#ebe9e9',
    required: '#f10d3d',
    border: '#d6d6d6',
    'language-selected': ' #333',
    text: '#999',
    'input-background': 'fff',
    background: '#eee',
    'input-text': '#969696',
    'logo-border': '#dfdfdf',
    'logo-background': '#fff',
    primary: '#94a545'
  },
  dark: {
    'panel-primary-background': '#222',
    'panel-secondary-background': '#2d2d2d',
    'panel-tertiary-background': '#393939',
    required: '#b90101',
    border: '#444',
    'language-selected': '#ededed',
    text: '#ccc',
    'input-background': '#111',
    background: '#333',
    'input-text': '#999',
    'logo-border': '#dfdfdf',
    'logo-background': '#fff',
    primary: '#94a545'
  }
};